import { Empty, Spin } from "antd";
import useHeatMap from "../hooks/useHeatMap";

function VerifyHeatMap({
  selectedDateRange,
  selectedPeriod,
  isLastRecordPending,
  normalizationMode,
  zoneScope,
  viewMode = "3d",
  personScope = "todos",
}) {
  const is2D = viewMode === "2d";
  const { data: heatmapData, isLoading } = useHeatMap({
    selectedDateRange,
    selectedPeriod,
    isLastRecordPending,
    normalizationMode,
    zoneScope,
    viewMode,
    personScope,
  });

  if (isLoading || isLastRecordPending) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          marginTop: "100px",
        }}>
        <Spin />
      </div>
    );
  }

  if (!heatmapData) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span>Nao ha informacoes disponiveis no momento.</span>}
      />
    );
  }

  return (
    <>
      <img
        src={heatmapData}
        alt="Heatmap"
        style={
          is2D
            ? {
                maxWidth: "680px",
                width: "100%",
                display: "block",
                margin: "0 auto",
              }
            : { width: "100%" }
        }
      />
    </>
  );
}

export default VerifyHeatMap;
